export default {"src":"/_next/static/media/tab_user.88f0d478.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};